import {Suspense} from 'react';
import {lazyWithRetry} from 'src/utils/lazyWithRetry';
import {Outlet} from 'react-router-dom';
// auth
import {AuthGuard} from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import {LoadingScreen} from 'src/components/loading-screen'

const EmployeesPage = lazyWithRetry(() => import('src/pages/employees/EmployeesPage'));

export const employeesRoutes = [
  {
    path: '/employees',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <EmployeesPage />,
      },
      {
        path: 'view/:id',
        element: <EmployeesPage />,
      },
      {
        path: 'settings/:id',
        element: <EmployeesPage />,
      },
    ],
  },
];
